import clsx from 'clsx'
import { IContainerProps } from './types'
import styles from './container.module.scss'
import applyBreakpointStyles from './applyBreakpointStyles'

const Container = ({ children, yAlign, xAlign, spacing, maxWidth, ...props }: IContainerProps) => {
  // creates CSS variables for each breakpoint, based on the properties passed
  const alignStyles = xAlign !== undefined ? applyBreakpointStyles(xAlign, 'container-xAlign') : {}
  const justifyStyles =
    yAlign !== undefined ? applyBreakpointStyles(yAlign, 'container-yAlign') : {}
  const spacingStyles =
    spacing !== undefined ? applyBreakpointStyles(spacing, 'container-spacing') : {}
  const maxWidthStyles =
    maxWidth !== undefined ? applyBreakpointStyles(maxWidth, 'container-maxWidth') : {}

  return (
    <div
      data-testid="mui-container"
      style={{
        ...alignStyles,
        ...justifyStyles,
        ...spacingStyles,
        ...maxWidthStyles,
        ...props.style,
      }}
      {...props}
      className={clsx(styles.container, props.className)}
    >
      {children}
    </div>
  )
}

export default Container
